export default theme => ({
  root: {
    position: 'relative',
    marginBottom: theme.spacing(3),
  },
});
